import { render, staticRenderFns } from "./mianshi.vue?vue&type=template&id=3b5010f4&scoped=true&"
import script from "./mianshi.vue?vue&type=script&lang=js&"
export * from "./mianshi.vue?vue&type=script&lang=js&"
import style0 from "./mianshi.vue?vue&type=style&index=0&id=3b5010f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5010f4",
  null
  
)

export default component.exports